// GenieX — links SEO product/solution pages to the real Shop catalog.

// Product page slug -> { slug: exact shop product slug } OR { category: fallback shop category }
export const PRODUCT_SHOP_MAP = {
  "dynamic-series": { slug: "dynamic-series-smart-switch" },
  "smart-touch-panels": { slug: "smart-touch-panels" },
  "smart-switches": { slug: "dynamic-series-smart-switch" },
  "scene-controllers": { slug: "scene-controllers" },
  "wireless-remotes": { category: "Switches" },
  "retro-modules": { category: "Switches" },

  "smart-dimmers": { slug: "smart-dimmers" },
  "led-strip-control": { slug: "led-strip-control" },
  "smart-bulbs": { slug: "smart-bulbs" },
  "mood-lighting": { category: "Lighting" },
  "color-tunable-lighting": { category: "Lighting" },
  "outdoor-garden-lighting": { category: "Lighting" },

  "curtain-motors": { slug: "geniex-curtain-motor" },
  "roller-blinds": { slug: "roller-blinds" },
  "roman-blinds": { category: "Automation" },
  "venetian-blinds": { category: "Automation" },
  "skylight-control": { category: "Automation" },

  "smart-locks": { slug: "geniex-smart-door-lock-pro" },
  "video-door-phones": { slug: "geniex-smart-video-doorbell" },
  "cctv-solutions": { slug: "cctv-solutions" },
  "gas-leak-detection": { slug: "gas-leak-detection" },
  "smoke-sensors": { slug: "smoke-sensors" },
  "water-leak-detection": { category: "Safety" },
  "panic-buttons": { category: "Safety" },

  "motion-sensors": { slug: "geniex-motion-sensor" },
  "presence-sensors": { category: "Sensors" },
  "door-window-sensors": { category: "Sensors" },
  "temperature-sensors": { category: "Sensors" },
  "air-quality-sensors": { slug: "air-quality-sensors" },
  "light-sensors": { category: "Sensors" },

  "ac-control": { slug: "ac-control" },
  "tv-control": { slug: "tv-control" },
  "robot-vacuum": { slug: "robot-vacuum" },
  "smart-geyser": { category: "Climate" },
  "smart-plugs": { slug: "geniex-smart-wi-fi-plug" },
  "pet-feeders": { slug: "pet-feeders" },

  "gate-automation": { category: "Automation" },
  "boom-barriers": { category: "Automation" },
  "sprinkler-automation": { category: "Automation" },
  "pool-control": { category: "Automation" },
  "driveway-sensors": { category: "Sensors" },
};

// Solution page slug -> ordered list of shop categories to pull "Recommended Products" from.
export const SOLUTION_SHOP_CATEGORIES = {
  "complete-home": ["Switches", "Security", "Sensors", "Automation"],
  "home-theatre": ["Entertainment", "Lighting", "Automation"],
  "smart-living": ["Switches", "Lighting", "Climate"],
  "home-security": ["Security", "Safety", "Sensors"],
  "energy-saving": ["Climate", "Plugs", "Sensors"],
  "elderly-friendly": ["Safety", "Sensors", "Security"],
  "child-safe": ["Safety", "Switches", "Sensors"],
  "rental": ["Switches", "Plugs", "Automation"],
  "hotel": ["Security", "Climate", "Entertainment"],
  "villas": ["Automation", "Sensors", "Security"],
  "apartments": ["Switches", "Security", "Climate"],
  "for-architects": ["Switches", "Automation"],
  "for-interior-designers": ["Lighting", "Switches"],
  "for-builders": ["Switches", "Security"],
  "for-homeowners": ["Switches", "Security", "Climate"],
};
